import * as $ from 'jquery';
// send all button
$("#btnSendSurveyAll").click(function (e) {
    e.preventDefault();
    // show modal
    $("#modalSendSurveyAll").modal("show");
    // prevent form submit
    return false;
});
// send now button
$("#btnSendNow").click(function (e) {
    e.preventDefault();
    // submit form
    $("#btnSendSurveyAll").closest("form").submit();
});
export default undefined;
